import { useEffect, useState } from 'react';

const readCompanyId = (): number => Number(localStorage.getItem('selectedCompanyId') || '') || 0;
const readCompanyName = (): string => localStorage.getItem('selectedCompanyName') || '';

/** The company picked in the top bar; follows the 'company-changed' event. */
export default function useCompanyId(): { companyId: number; companyName: string } {
  const [state, setState] = useState(() => ({ companyId: readCompanyId(), companyName: readCompanyName() }));
  useEffect(() => {
    const onChange = () => setState({ companyId: readCompanyId(), companyName: readCompanyName() });
    window.addEventListener('company-changed', onChange);
    return () => window.removeEventListener('company-changed', onChange);
  }, []);
  return state;
}
